import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import classes from "./Activities.module.css";
import styles from "./activityCards.module.css";
import { testUrl } from "../BaseData";
import Pagination from "@mui/material/Pagination";

const GreenRenessans = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // activity type object (has site_details from admin)
  const [activityType, setActivityType] = useState(null);

  // Sidebar
  const [category, setCategory] = useState(null);
  const [activityTypes, setActivityTypes] = useState([]);

  // Cards
  const [activitiesPost, setActivitiesPost] = useState([]);
  const [pageApi, setPageApi] = useState(1);
  const itemsPerPage = 8; // leave room for the "about" card on page 1

  const sortSidebarItems = (items) => {
    const navbarOrder = [
      "ilmiy-jarayonlar",
      "ilmiy-kengash",
      "ilmiy-konferensiyalar",
      "journal",
      "ilmiy-maktablar",
      "green-renessans",
      "oquv-va-labaratoriya-bazalari",
      "axborotlashtirish-jarayonlari",
      "yosh-akademiklar",
      "grantlar-va-loyihalar",
      "avtorefereat-dissertatsiya",
    ];
    return items.sort((a, b) => {
      const ai = navbarOrder.indexOf(a.short_name);
      const bi = navbarOrder.indexOf(b.short_name);
      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return 0;
    });
  };

  useEffect(() => {
    setLoading(true);
    setError(null);

    axios
      .get(testUrl + "/api/baseactivity/ilmiy-faoliyat/green-renessans")
      .then((res) => {
        const data = res.data;
        if (data) {
          setCategory(data.category || null);
          const excluded = [
            "amaliyot-shartnomalari",
            "talim-jarayoni-hujjatlari",
            "talim-jarayoni-meyoriy-hujjatlari",
            "oquv-reja-va-syllabus",
          ];
          const types = (data.activities_types || []).filter(
            (t) => !excluded.includes(t.short_name)
          );
          setActivityTypes(sortSidebarItems(types));
          setActivitiesPost(data.activities_post || []);

          // activity object contains site_details (editable from admin)
          setActivityType(data.activity || null);
        }
      })
      .catch(() => setError("Ma'lumotlarni yuklashda xatolik"))
      .finally(() => setLoading(false));
  }, [i18n.language]);

  if (loading) return <div>Yuklanmoqda...</div>;
  if (error) return <div>{error}</div>;

  const currentShort = "green-renessans";

  // Get site_details from the activity type (admin editable)
  const siteDetails =
    activityType?.[`site_details_${currentLang}`] ||
    activityType?.site_details_uz ||
    "";

  // Pagination: on page 1 the "about" card takes 1 slot
  const effectivePerPage = itemsPerPage;
  const indexOfLast = pageApi * effectivePerPage;
  const indexOfFirst = indexOfLast - effectivePerPage;
  const currentActivities = activitiesPost.slice(indexOfFirst, indexOfLast);

  // Total pages: if siteDetails exists it adds 1 extra card only on page 1
  const totalPosts = activitiesPost.length;
  const totalWithAbout = siteDetails ? totalPosts + 1 : totalPosts;
  const totalPages = Math.ceil(totalWithAbout / effectivePerPage);

  return (
    <div className={classes["mainContainer"]}>
      <div data-aos="fade-up" className={classes["container"]}>
        <h1 className={classes["page-title"]}>{t("Green Renessans")}</h1>

        <div className={styles.facultyGrid}>
          {/* "About" card — shown on page 1 only, content editable from admin */}
          {siteDetails && pageApi === 1 && (
            <div
              className={styles.activityCard}
              onClick={() =>
                navigate("/activity/ilmiy-faoliyat/green-renessans/about")
              }
            >
              <div
                className={styles.activityImage}
                style={{
                  background: "linear-gradient(135deg, #1e3a5f 0%, #4e9efc 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "220px",
                }}
              >
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 80 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="40" cy="40" r="38" stroke="white" strokeWidth="3" strokeOpacity="0.4" />
                  <path
                    d="M28 40 C28 28 52 28 52 40 C52 52 28 52 28 40Z"
                    stroke="white"
                    strokeWidth="2.5"
                    fill="none"
                  />
                  <path
                    d="M40 28 C34 28 28 34 28 40 C28 46 34 52 40 52"
                    stroke="white"
                    strokeWidth="2.5"
                    fill="none"
                  />
                  <path d="M40 28 V52" stroke="white" strokeWidth="2.5" />
                  <path d="M28 40 H52" stroke="white" strokeWidth="2.5" />
                  <circle cx="40" cy="40" r="5" fill="white" />
                </svg>
              </div>
              <div className={styles.activityInfo}>
                <h3>
                  {activityType?.[`name_${currentLang}`] ||
                    t("Green Renessans haqida")}
                </h3>
              </div>
            </div>
          )}

          {/* Dynamic cards from admin */}
          {currentActivities.filter(Boolean).map((item) => (
            <div
              key={item.id}
              className={styles.activityCard}
              onClick={() => navigate(`/activity/${item.id}`)}
            >
              <img
                src={item.image}
                alt={item[`name_${currentLang}`] || ""}
                className={styles.activityImage}
              />
              <div className={styles.activityInfo}>
                <h3>{item[`name_${currentLang}`]}</h3>
              </div>
            </div>
          ))}
        </div>

        {totalPages > 1 && (
          <div style={{ display: "flex", justifyContent: "center", margin: "24px 0" }}>
            <Pagination
              onChange={(e, value) => setPageApi(value)}
              count={totalPages}
              page={pageApi}
              variant="outlined"
              shape="rounded"
            />
          </div>
        )}
      </div>

      <div className={classes.sidebar}>
        <h3>{category ? category[`name_${i18n.language}`] : t("categories")}</h3>
        <ul>
          {activityTypes.filter(Boolean).map((cat) => (
            <li
              key={cat.id}
              className={cat.short_name === currentShort ? classes.active : ""}
              onClick={() =>
                navigate(`/activity/${category?.short_name}/${cat.short_name}`)
              }
            >
              {cat[`name_${i18n.language}`]}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GreenRenessans;